import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";
import { images } from "../data/images";

export default function Specifications() {
  const { t } = useLanguage();
  const tx = translations.specs;

  return (
    <section className="relative bg-[#2A2A28] text-[#F5F0E8] py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={images.heroAerial3}
          alt="NACUII villa aerial"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-[#2A2A28]/85" />
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-[1px] w-10 bg-[#9C8456]" />
            <span
              className="text-[#C9B789] text-[11px] tracking-[0.45em] uppercase"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.eyebrow)}
            </span>
            <div className="h-[1px] w-10 bg-[#9C8456]" />
          </div>
          <h2
            className="text-[34px] sm:text-[48px] lg:text-[58px] leading-[1.08] max-w-3xl mx-auto"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
          >
            {t(tx.title1)} <em className="italic">{t(tx.title2)}</em>
          </h2>
          <p
            className="text-[#C9B789] text-[12px] lg:text-[13px] tracking-[0.3em] uppercase mt-7"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
          >
            {t(tx.summary)}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#3a3a36]">
          {tx.items.map((spec, i) => (
            <div
              key={i}
              className="bg-[#2A2A28] p-7 lg:p-9 text-center hover:bg-[#34342f] transition-colors duration-500"
            >
              <p
                className="text-[#C9B789] text-[10px] tracking-[0.35em] uppercase mb-4"
                style={{ fontFamily: "'Jost', sans-serif" }}
              >
                {t(spec.label)}
              </p>
              <p
                className="text-[26px] lg:text-[34px] leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
              >
                {typeof spec.value === "string" ? spec.value : t(spec.value)}
              </p>
              <p
                className="text-[#9C8456] text-[12px] mt-2 tracking-wider"
                style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
              >
                {typeof spec.sub === "string" ? spec.sub : t(spec.sub)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-10 lg:gap-16 max-w-4xl mx-auto">
          <div>
            <h4
              className="text-[#C9B789] text-[12px] tracking-[0.35em] uppercase mb-5"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.viewLabel)}
            </h4>
            <p
              className="text-[20px] lg:text-[24px] leading-[1.4] text-[#F5F0E8]/95"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
            >
              {t(tx.viewText)}
            </p>
          </div>
          <div>
            <h4
              className="text-[#C9B789] text-[12px] tracking-[0.35em] uppercase mb-5"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.techLabel)}
            </h4>
            <p
              className="text-[20px] lg:text-[24px] leading-[1.4] text-[#F5F0E8]/95"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
            >
              {t(tx.techText)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
